import { render, staticRenderFns } from "./FeaturesOverview.vue?vue&type=template&id=3fe09f22&scoped=true&lang=html&"
import script from "./FeaturesOverview.vue?vue&type=script&lang=js&"
export * from "./FeaturesOverview.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesOverview.vue?vue&type=style&index=0&id=3fe09f22&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe09f22",
  null
  
)

export default component.exports